import React from "react";
import "../styles.css";

type CoachMarkStepOneProps = {
  visible: boolean;
  userName?: string;
  onPlay: () => void;
};

const CoachMarkStepOne = ({
  visible,
  userName = "there",
  onPlay,
}: CoachMarkStepOneProps) => {
  if (!visible) return null;

  return (
    <div className="coachmark-overlay" role="dialog" aria-modal="true" aria-label="Coach mark step one">

      <div className="coachmark-step-one-card">
        <div className="coachmark-step-one-inner">
          <img
            src={require("../../assets/coachmarking_welcome_text.png")}
            alt="welcome to"
            className="coachmark-welcome-text"
          />

          <div className="coachmark-logo-row">
            <img
              src={require("../../assets/u4uOnb.png")}
              alt="U4U"
              className="coachmark-u4u-logo"
            />
            <img
              src={require("../../assets/Item2.png")}
              alt="U mascot"
              className="coachmark-u-logo"
            />
          </div>

          <button
            type="button"
            className="coachmark-play-btn"
            onClick={onPlay}
          >
            <span>PLAY</span>
            <img
              src={require("../../assets/arrow-left-coach.png")}
              alt="Play"
              aria-hidden="true"
              className="coachmark-play-arrow"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoachMarkStepOne;
